import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { RegisterEmployee } from '@app/_models/registerEmployee';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { BehaviorSubject, Observable,throwError, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { headervalue } from 'src/headervalue/header';

const httpOptions = {
  // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })

export class RegisterEmployeeService {
  constructor(private http: HttpClient) { }

  addRegister1(RegisterParam: RegisterEmployee): Observable<RegisterEmployee> {
    return this.http.post<RegisterEmployee>(`${environment.apiUrl}/auth/employerSignUp`, RegisterParam, httpOptions).pipe(
      //   tap((onDemandSettingsParam: Register) => this.log('saved onDemandSettingsParam')),
      //   catchError(this.handleError<Register>('addSettings'))
    );
  }

  addRegister(userdata): Observable<any> {
    console.log("userdata", userdata)
    return this.http.post(`${environment.apiUrl}/auth/employerSignUp`, userdata,httpOptions).pipe(catchError(this.handleError),);
}

handleError(error: HttpErrorResponse) {
    return throwError(error);
}

  private handleError1<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      //  this.errorparam = this.onDemandSettingsParam.Error;
      //console.warn("HI Ashwini");
      console.log(error);
      // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}